import * as React from 'react';
import {connect} from "react-redux";
import authDispatch from '../../ReduxRequests/Dispatch/authDispatch';
import authState from '../../ReduxRequests/State/authState';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {URL} from '../../Config/appConfig';

const logo = require('../../resource/img/logo.svg');
const btnSpinner = require('../../resource/img/button-loading.gif');

interface UnsubscriptionProps {
    unsubscribe: () => void,
    unsubscriptionConfirmed?: boolean,
    selectInsurer: () => void
}

interface UnsubscriptionState {
    loading: boolean
}

class Unsubscription extends React.Component <RouteComponentProps & UnsubscriptionProps, UnsubscriptionState> {
    public constructor(props: UnsubscriptionProps) {
        super(props);
        this.state = {
            loading: false
        };
        this.goToDashboard = this.goToDashboard.bind(this);
        this.clickConfirm = this.clickConfirm.bind(this);
    }

    public componentWillReceiveProps(nextProps: UnsubscriptionProps) {
        if (nextProps.unsubscriptionConfirmed !== this.props.unsubscriptionConfirmed) {
            this.setLoading(false);
        }
    }

    public setLoading(loading: boolean) {
        this.setState({loading});
    }

    public goToDashboard(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.props.auth().insurer ? this.props.history.push(URL.DASHBOARD) : this.props.selectInsurer(true);
    }

    public clickConfirm(event: React.MouseEvent<HTMLElement> | React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        this.setLoading(true);
        this.props.unsubscribe();
    }

    public render() {
        return (
            <div className="cmCenter loginContainer">
                <button className="cmHorCenter" onClick={this.goToDashboard}>
                    <img src={logo}/>
                </button>
                <div className="cmText loginLabel authLabel">Unsubscribe</div>
                <div className="cmText authInfoText">Are you sure you want to unsubscribe the Daily Activity Report?</div>
                <form onSubmit={this.clickConfirm}>
                    <div className="cmBtnsContainer">
                        <div className="cmBtnWrapper">
                            <button type="button" className="cmBtn cmGreyBtn cmBoldText" disabled={this.state.loading} onClick={this.goToDashboard}>Cancel</button>
                        </div>
                        <div className="cmBtnWrapper">
                            <button className="cmBtn cmBlueBtn cmBoldText" onClick={this.clickConfirm}
                                    disabled={this.state.loading}>
                                <span className="cmBtnText">Confirm</span>
                                {this.state.loading && <img className="cmBtnSpinner" src={btnSpinner}/>}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

export default withRouter(connect(authState, authDispatch)(Unsubscription));



// WEBPACK FOOTER //
// ./src/Components/Unsubscription/Unsubscription.tsx